/* eslint-disable */
import { buildConfig } from './build-config';
import { getBuildEnvVar, getRuntimeEnvVar } from '@wizbii-utils/angular/core';
import { LangEnum, LocaleEnum } from '@wizbii/utils/models';

const packageJsonVersionAtBuild = require('../../package.json').version; // eslint-disable-line

// @ts-ignore
const production: boolean = buildConfig === 'production';
const ciCommitSha = getBuildEnvVar('CI_COMMIT_SHA');
const analyticsUai = getRuntimeEnvVar('WIZBII_ANALYTICS_UAI');
const googleAnalyticsUai = getRuntimeEnvVar('GOOGLE_ANALYTICS_UAI');

const wizbiiDomain = getRuntimeEnvVar('WIZBII_DOMAIN');
const wizbiiDomainIt = getRuntimeEnvVar('WIZBII_DOMAIN_ITALY');
const wizbiiDomainEs = getRuntimeEnvVar('WIZBII_DOMAIN_SPAIN');
const wizbiiDomainDe = getRuntimeEnvVar('WIZBII_DOMAIN_GERMANY');

const oldAccount = `https://account-v1.${wizbiiDomain}`;

const deployAssetsUrl = production
  ? `https://storage.googleapis.com/wizbii-application-assets/account-v2/${getBuildEnvVar('CI_COMMIT_SHA')}/fr/assets`
  : null;

export const environment = {
  applicationId: 'account',
  contactEmailKey: 'account',
  deployAssetsUrl,
  platform: getRuntimeEnvVar('PLATFORM'),
  domain: wizbiiDomain,
  isDeployed: ciCommitSha !== 'local',
  isProdBuild: production,
  version: production ? packageJsonVersionAtBuild : getBuildEnvVar('GIT_BRANCH_NAME'),
  lang: getBuildEnvVar('LANG'),
  locale: getBuildEnvVar('LOCALE'),
  bugsnagId: '284a6cb2f6672f0a5b0d0d0c11c9654a',
  domainsByLang: {
    [LangEnum.fr]: wizbiiDomain,
    [LangEnum.en]: wizbiiDomain,
    [LangEnum.it]: wizbiiDomainIt,
    [LangEnum.es]: wizbiiDomainEs,
    [LangEnum.de]: wizbiiDomainDe,
  },
  domainsByLocale: {
    [LocaleEnum.fr_FR]: wizbiiDomain,
    [LocaleEnum.en_GB]: wizbiiDomain,
    [LocaleEnum.it_IT]: wizbiiDomainIt,
    [LocaleEnum.es_ES]: wizbiiDomainEs,
    [LocaleEnum.de_DE]: wizbiiDomainDe,
  },
  api: {
    googleStorage: 'https://storage.googleapis.com',
    sso: `https://sso.internal.${wizbiiDomain}`,
  },
  urls: {
    oldAccount,
  },
  analytics: {
    waTrackingId: analyticsUai,
    gaTrackingId: googleAnalyticsUai,
    gaConversionId: {
      [LocaleEnum.fr_FR]: 'AW-874490256',
      [LocaleEnum.en_GB]: 'AW-874490256',
      [LocaleEnum.es_ES]: 'AW-10866647616',
      [LocaleEnum.it_IT]: 'AW-10866697118',
      [LocaleEnum.de_DE]: 'AW-17385190188',
    },
    hotjar: {
      id: '2048440',
      version: '6',
    },
    yahoo: {
      projectId: '10000',
      pixelId: '10131589',
    },
    twitter: {
      twitterId: getRuntimeEnvVar('TWITTER_PIXEL_ID'),
      version: getRuntimeEnvVar('TWITTER_PIXEL_VERSION'),
    },
    pinterest: {
      pixelId: '2612995435269',
      pixelVersion: '3.0',
    },
    outbrain: {
      pixelId: '00b438cb0a514efa94cda1579bc7c53b0e',
      pixelVersion: '1.1',
    },
    criteo: {
      appId: '59994',
    },
    taboola: {
      appId: '1801183',
    },
  },
  signupUrls: {
    jobs: `https://www.${wizbiiDomain}`,
    account: `https://www.${wizbiiDomain}/account/sign-up`,
  },
  tiktok: {
    [LocaleEnum.fr_FR]: {
      fibii: 'C6BP84RA1SKIVFQVLF0G',
      jobs: 'C5P8C9DODNNK397VRGCG',
    },
    [LocaleEnum.en_GB]: {
      fibii: 'C6BP84RA1SKIVFQVLF0G',
      jobs: 'C5P8C9DODNNK397VRGCG',
    },
    [LocaleEnum.es_ES]: {
      fibii: 'C96RAA3C77U7KEOR57MG',
    },
    [LocaleEnum.it_IT]: {
      fibii: 'C96RFBRC77U7KEOR57TG',
    },
    [LocaleEnum.de_DE]: {
      fibii: 'D1VNO1BC77UCQ41ML44G',
    },
  },
  facebookLogin: {
    appId: getRuntimeEnvVar('FACEBOOK_CONNECT_KEY'),
    version: getRuntimeEnvVar('FACEBOOK_CONNECT_VERSION'),
  },
  facebookPixel: {
    [LocaleEnum.fr_FR]: {
      jobs: {
        id: '727985974263933',
        version: '2.0',
      },
      fibii: {
        id: '989496764853730',
        version: '2.0',
      },
    },
    [LocaleEnum.en_GB]: {
      jobs: {
        id: '727985974263933',
        version: '2.0',
      },
      fibii: {
        id: '989496764853730',
        version: '2.0',
      },
    },
    [LocaleEnum.es_ES]: {
      fibii: {
        id: '381739360280604',
        version: '2.0',
      },
    },
    [LocaleEnum.it_IT]: {
      fibii: {
        id: '704368087678574',
        version: '2.0',
      },
    },
    [LocaleEnum.de_DE]: {
      fibii: {
        id: '1732356657653151',
        version: '2.0',
      },
    },
  },
  neuvoo: {
    jobs: 'wizbii',
  },
  bingPixel: {
    [LocaleEnum.fr_FR]: {
      jobs: '56348309',
      fibii: '56314483',
    },
    [LocaleEnum.en_GB]: {
      jobs: '56348309',
      fibii: '56314483',
    },
    [LocaleEnum.es_ES]: {
      jobs: '149007515',
      fibii: '149007515',
    },
    [LocaleEnum.it_IT]: {
      jobs: '149007516',
      fibii: '149007516',
    },
  },
  snapchatPixel: {
    [LocaleEnum.fr_FR]: {
      fibii: '82e21569-d654-4a1e-bb29-ff9497f89a7c',
    },
    [LocaleEnum.en_GB]: {
      fibii: '82e21569-d654-4a1e-bb29-ff9497f89a7c',
    },
    [LocaleEnum.es_ES]: {
      fibii: '57ffe7b3-b1aa-4b8d-a535-a69441e2931f',
    },
    [LocaleEnum.it_IT]: {
      fibii: '335e7a86-1566-41dd-8d2a-06f7e5254185',
    },
    [LocaleEnum.de_DE]: {
      fibii: 'd661f35e-492b-43de-b9a6-8b7493034990',
    },
  },

  awin: {
    merchantId: '41878',
  },
  googleTagManagerId: {
    fibii: {
      id: 'GTM-MMF3MGV',
    },
  },
  emailPreferencesToken: getRuntimeEnvVar('WIZBII_EMAIL_PREFERENCES_TOKEN'),
  googleLoginProvider: getRuntimeEnvVar('GOOGLE_CONNECT_KEY'),
  wizbiiFiles: getRuntimeEnvVar('WIZBII_FILES_GCS_BUCKET'),
  appleLogin: {
    redirectUri: `https://www.${wizbiiDomain}/account/_hook/apple`,
    serviceBundle: getRuntimeEnvVar('APPLE_CONNECT_SERVICE_BUNDLE'),
  },
};
